module.exports = __webpack_public_path__ + "img/DickeBacken.afdbb01d.svg";